import { render, staticRenderFns } from "./DialogManager.vue?vue&type=template&id=2a135e20"
import script from "./DialogManager.vue?vue&type=script&lang=ts"
export * from "./DialogManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports